import React from 'react';
import TopNavigation from '../components/TopNavigation';

const About: React.FC = () => {
  return (
    <div style={styles.container}>
      <TopNavigation />
      <div style={styles.contentArea}>
        <header style={styles.header}>
          <h1 style={styles.title}>About Belivah</h1>
          <p style={styles.subtitle}>A positive social platform to inspire, uplift, and connect.</p>
        </header>

        <section style={styles.section}>
          <h2 style={styles.h2}>Our Mission</h2>
          <p style={styles.p}>
            Belivah brings people together to share stories, testimonies, music, and meaningful conversations. We celebrate
            creativity and community while prioritizing safety, privacy, and user control.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>What We Offer</h2>
          <ul style={styles.ul}>
            <li>Testimonies to uplift and inspire</li>
            <li>Pulse short-form videos for quick motivation</li>
            <li>Groups for thoughtful discussion</li>
            <li>Stories, Music, Live sessions, and more</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Our Commitment</h2>
          <p style={styles.p}>
            We strive to foster a respectful environment with clear community guidelines and accessible tools to report issues.
            We continuously improve our features to provide a beautiful and safe experience.
          </p>
        </section>
      </div>
    </div>
  );
};

const styles: { [k: string]: React.CSSProperties } = {
  container: { display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--color-background-alt)' },
  contentArea: { paddingTop: '80px', maxWidth: '900px', margin: '0 auto', padding: '20px' },
  header: { background: '#0B6B6F', color: '#fff', padding: '20px 24px', borderRadius: 12 },
  title: { margin: 0, fontSize: 28 },
  subtitle: { margin: '6px 0 0 0', fontSize: 14 },
  section: { background: '#fff', borderRadius: 12, padding: 20, marginTop: 16, border: '1px solid var(--color-border)' },
  h2: { margin: '0 0 10px 0', color: '#072B2C', fontSize: 20 },
  p: { margin: 0, color: '#072B2C' },
  ul: { margin: '0 0 0 18px', color: '#072B2C' },
};

export default About;
